/**
 * Created by wjohnald on 9/28/16.
 */

var ACTION_TYPES = require('./actionTypes');

var actionCreators = {};

/**
 * clientId will be a way to ensure that we're requesting the
 * correct model from model manager
 *
 *
 * @param clientId
 * @returns {{type: *, payload: {clientId: *}}}
 */
function pollingStatusInitiated(clientId, title) {

  return {
    type: ACTION_TYPES.POLLING_STATUS_INITIATED,
    payload: {
      clientId: clientId,
      title:    title
    }
  };
}
actionCreators.pollingStatusInitiated = pollingStatusInitiated;

/**
 *
 * @param clientId
 * @param id
 * @param imageUrl
 * @param title
 * @param status
 * @param description
 * @param polling
 * @returns {{type: *, payload: {id: *, imageUrl: *, title: *, status: *, description: *, polling: *, cid: *}}}
 */
function pollingStatusHydrated(clientId, id, imageUrl, title, status, description, polling, modelEditUrl, model3DToolsUrl) {
  return {
    type: ACTION_TYPES.POLLING_STATUS_UPDATED,
    payload: {
      clientId:     clientId,
      id:           parseInt(id, 10),
      imageUrl:     imageUrl,
      title:        title,
      status:       status,
      description:  description,
      polling:      !!polling,
      modelEditUrl: modelEditUrl,
      model3DToolsUrl: model3DToolsUrl
    }
  };
}
actionCreators.pollingStatusHydrated = pollingStatusHydrated;

/**
 *
 * @param id
 * @param imageUrl
 * @param title
 * @param status
 * @param description
 * @param polling
 * @returns {{type: *, payload: {id: *, imageUrl: *, title: *, status: *, description: *, polling: *, cid: *}}}
 */
function pollingStatusUpdated(id, imageUrl, title, status, description, polling, singleModel, modelEditUrl, model3DToolsUrl) {
  return {
    type: ACTION_TYPES.POLLING_STATUS_UPDATED,
    payload: {
      id:           parseInt(id, 10),
      imageUrl:     imageUrl,
      title:        title,
      status:       status,
      description:  description,
      polling:      !!polling,
      singleModel: singleModel,
      modelEditUrl: modelEditUrl,
      model3DToolsUrl: model3DToolsUrl

    }
  };
}
actionCreators.pollingStatusUpdated = pollingStatusUpdated;

/**
 *
 * @param clientId
 * @param progress
 * @returns {{type: *, payload: {clientId: *, progress: *}}}
 */
function pollingStatusUpdateProgress(clientId, progress) {
  return {
    type: ACTION_TYPES.POLLING_STATUS_UPDATED,
    payload: {
      clientId: clientId,
      progress: parseInt(progress, 10)
    }
  };
}
actionCreators.pollingStatusUpdateProgress = pollingStatusUpdateProgress;

/**
 *
 * @param clientId
 * @param failureMessage
 * @returns {{type: *, payload: {clientId: *, status: string, isFailed: boolean}}}
 */
function pollingStatusFailed(clientId, failureMessage) {
  return {
    type: ACTION_TYPES.POLLING_STATUS_UPDATED,
    payload: {
      clientId:       clientId,
      status:         'failed',
      isFailed:       true,
      failureMessage: failureMessage
    }
  };
}
actionCreators.pollingStatusFailed = pollingStatusFailed;

/**
 *
 * @param id
 * @param imageUrl
 * @param title
 * @param status
 * @param description
 * @param polling
 * @returns {{type: *, payload: {id: *, imageUrl: *, title: *, status: *, description: *, polling: *}}}
 */
function pollingStatusCompleted(id, imageUrl, title, status, description, polling) {
  return {
    type: ACTION_TYPES.POLLING_STATUS_COMPLETED,
    payload: {
      id:           parseInt(id, 10),
      imageUrl:     imageUrl,
      title:        title,
      status:       status,
      description:  description,
      polling:      !!polling
    }
  };
}
actionCreators.pollingStatusCompleted = pollingStatusCompleted;


module.exports = actionCreators;
